import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MetadataService } from './shared/services/metadata.service';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
})
export class AppComponent implements OnInit {
  constructor(private metadataService: MetadataService) {}

  ngOnInit(): void {
    this.metadataService.setDefaultTags();
  }
}
